import axios from "./axios"; // Import the centralized Axios instance

const state = {
  user: {}
};

const getters = {
  detailUser: (state) => state.user
};

const actions = {
  async fetchUser({ commit }) {
    try {
      commit('resetUser');
      const response = await axios.get(`auth/auto-login`);
      const data = await response.data;
      commit('setUser', data);
    }
    catch (error) {
      console.error('Failed to fetch user: ', error)
    }
  },
  async updateUser({ commit }, userData) {
    try {
      const response = await axios.put(`users/${userData.id}`, userData);
      const data = response.data;
      commit('setUser', data);
      return data;
    }
    catch (error) {
      console.error('Failed to update user: ', error);
      throw error;
    }
  },
  async changePassword({ commit }, dataPassword ) {
    try {
      const response = await axios.put(`users/${dataPassword.id}`, dataPassword);
      const data = response.data;
      commit('setUser', data);
      return data;
    }
    catch (error) {
      console.error('Failed to change password: ', error);
      throw error;
    }
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user.data;
  },
  resetUser(state) {
    state.user = {};
  }
};

export default {
  namespaced: true,
  state, mutations, actions, getters
}